'use strict';
var localisations = require('./admin.localisations');

export default class AdminController {
  /*@ngInject*/
  constructor(User, common, Auth, groups) {
    // Use the User $resource to fetch all users
    var that = this;
    this.users = User.query();
    this.common = common;
    this.common.setBack(null, null);
    this.groups = groups;
    that.groups.initialise(function(data){
      that.common.setLoading(false);
    }, function(){
      that.common.setLoading(false);
    });
    this.localisations = localisations[this.common.getLocale()];
    this.high = 18;
    this.low = 12;
    this.confirmMessage = "Are you sure you want to delete?";
    this.confirmFunction = "delete";
    this.Auth = Auth;
    this.userToUpdate = null;
    this.roleToSet = 'user';
    this.showConfirm = false;
    this.showingModeratorGroups = '';
    this.savedgroups = [];
  }

  addGroups(user) {
    this.showingModeratorGroups = user._id;
    this.savedgroups = JSON.parse(JSON.stringify(user.uac));
  }

  updateGroups(user) {
    this.showingModeratorGroups = "";
    var that = this;
    this.Auth.updateGroups(user._id, user.uac, function() {
    }, function() {
      that.common.setAlert('Save Error', 'danger', 'Looks like there is a problem updating this profile. Please check the details and try again.', false, true);
    });
  }

  cancelGroups(user) {
    user.uac = this.savedgroups;
    this.showingModeratorGroups = "";
  }

  confirm(user, type, role) {
    this.userToUpdate = user;
    this.roleToSet = role;
    switch(type) {
      case "delete":
        this.confirmMessage = "Are you sure you want to delete this user?";
        this.confirmFunction = "delete";
        break;
      case "role":
        switch(role) {
          case 'admin':
            this.confirmMessage = "Are you sure you want to make this person an administrator?";
            break;
          case 'moderator':
            this.confirmMessage = "Are you sure you want to make this person a moderator?";
            break;
          case 'user':
            this.confirmMessage = "Are you sure you want to make this person an ordinary user?";
            break;
        }
        this.confirmFunction = "role";
        break;
    }
    this.showConfirm = user._id;
  }

  confirmAction() {
    switch(this.confirmFunction) {
      case 'delete':
        this.delete();
        break;
      case 'role':
        this.updateRole();
        break;
    }
  }

  cancelAction() {
    this.showConfirm = false;
    this.userToUpdate = {};
    this.roleToSet = '';
    this.confirmMessage = "";
    this.confirmFunction = "";
  }

  addGroupToList(user, group) {
    if (this.groupPresent(user, group._id)) {
      var index = user.uac.map(function(grp){ return grp._id; }).indexOf(group._id);
      user.uac.splice(index, 1);
    } else {
      user.uac.push(group);
    }
  }

  groupPresent(user, id){
    if (user.uac.map(function(grp){ return grp._id; }).indexOf(id) > -1) {
      return true
    } else {
      return false;
    }
  }

  updateRole() {
    var that = this;
    this.Auth.updateRole(this.userToUpdate._id, this.roleToSet, function() {
      that.users[that.users.indexOf(that.userToUpdate)].role = that.roleToSet;
      that.showConfirm = false;
      that.userToUpdate = {};
      that.roleToSet = '';
      that.confirmMessage = "";
      that.confirmFunction = "";
    }, function() {
      that.common.setAlert('Save Error', 'danger', 'Looks like there is a problem updating this profile. Please check the details and try again.', false, true);
      that.showConfirm = false;
      that.userToUpdate = {};
      that.roleToSet = '';
      that.confirmMessage = "";
      that.confirmFunction = "";
    });
  }

  delete() {
    console.log(this.userToUpdate);
    this.userToUpdate.$remove();
    this.users.splice(this.users.indexOf(this.userToUpdate), 1);
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js